import { IUser } from '@lb/api/mylb/interfaces';
import { ILearner } from '@lb/api/mylb/interfaces/ilearner.interface';

export interface ILearnerUsersState {
	learners: ILearner[];
	activeLearnerUser: IUser | undefined;
	learnersLoaded: boolean;
	learnersLoading: boolean;
	activeUserLoaded: boolean;
	activeUserLoading: boolean;
	activeUserUpdating: boolean;
	isAdminImpersonating: boolean;
}

export const initLearnerUsersState: ILearnerUsersState = {
	learners: [],
	activeLearnerUser: undefined,
	learnersLoaded: false,
	learnersLoading: false,
	activeUserLoaded: false,
	activeUserLoading: false,
	activeUserUpdating: false,
	isAdminImpersonating: false
};
